import { render, staticRenderFns } from "./EventDetailView.vue?vue&type=template&id=374c4187&"
import script from "./EventDetailView.vue?vue&type=script&lang=js&"
export * from "./EventDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports